<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>Policy</strong>
            <small>Setting up Check methods.</small>
            <small class="float-right">{{model.created_at | datetime}}</small>
          </div>
          <b-row>
            <b-col md="8">
              <b-form-group v-if="model && model.policy">
                <label for="ph_policy" v-b-tooltip.hover>Policy Description</label>
                <b-form-input type="text" id="ph_descrip" v-model="model.description" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label for="ph_depth" v-b-tooltip.hover title="Enter whether to check by moving (path) the link from the first page to the next. Can be specified within the range 1-100.">Maximum path depth</label>
                <b-form-input type="number" id="ph_depth" :min="1" :max="100" v-model="model.policy.depth" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_links" v-b-tooltip.hover title="Enter the maximum sublink to navigate within a page. Ignore any excess links. Normally, if too many links exist on one page, you can reach the maximum navigation page before navigating to the other to prevent it from not being checked in a balanced way. You can specify it within the range of 1-1,000.">Sub Page Link</label>
                <b-form-input type="number" id="ph_links" :min="1" :max="1000" v-model="model.policy.links" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_limit" v-b-tooltip.hover title="`Total number of pages to check on the inspection site. End the check when the entered number is reached. can be specified within the range of 1 to license limit.`">Maximum Navigation Page</label>
                <b-form-input type="number" id="ph_limit" :min="10" :max="limit" v-model="model.policy.limit" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label for="ph_timeout" v-b-tooltip.hover title="Time to wait for page loading. can be specified within the range of 1-30.">TimeOut(Second)</label>
                <b-form-input type="number" id="ph_timeout" :min="1" :max="30" v-model="model.policy.timeout" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_delay" v-b-tooltip.hover title="Time to wait before moving to a new page. can be specified within the range of 1 to 10,000.">Check Speed(Millisecond)</label>
                <b-form-input type="number" id="ph_delay" :min="0" :max="10000" v-model="model.policy.delay" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <template v-if="lock">
            <template v-if="model.is_del">
              <!-- <b-button size="sm" variant="success" @click="revive"> 되살리기 </b-button> -->
              <span>was deleted policy.</span>
            </template>
            <template v-else>
              <b-button size="sm" variant="primary" @click="edit"> Edit </b-button>
              <b-button size="sm" variant="danger" @click="remove"> Remove </b-button>
            </template>
          </template>
          <template v-else>
            <b-button size="sm" variant="success" @click="save"> Saved </b-button>
            <b-button size="sm" variant="default" @click="cancel"> Cancel </b-button>
          </template>
          <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> List </b-button>
        </b-card>
        <hr>
        <siteList v-if="model.id" :policy_id="model.id" :enable_new="false"></siteList>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Api } from '@/service';
import siteList from '../site/Site.List'

const policy = {
  S : { depth: 5, links: 20, limit: 50 },
  M : { depth: 10, links: 50, limit: 2000 },
  L : { depth: 20, links: 100, limit: 10000 }
}
export default {
  components : { siteList },
  data : () => {
    return {
      limit : 0,
      confirm: false,
      add: false,
      lock: true,
      model : { description: 'Sample', policy: { depth: 5, links: 20, limit: 0, timeout: 5, delay: 500 } },
      policy : policy,
      config : {},
    }
  },
  computed : {

  },
  methods: {
    async check_max_page(){
      let rs = await Api.Manager_Call('wmds.policy', 'page.limit', '')
      if(rs.error) { return this.$toastr.e("license check failed") }
      this.model.policy.limit = rs.body;
      this.limit = this.model.policy.limit
    },
    cancel() { this.$router.replace({ name: 'wmds_policy', params: { id: this.model.id }}); },
    edit() { this.$router.replace({ name: 'wmds_policy', params: { id: this.model.id, tag: 'edit' }}); },
    refresh() { this.$emit("refresh") },
    async remove() {
      try{
        let rs = await Api.Manager_Call('wmds.policy', 'delete', { id : this.model.id })
        if(rs.error) { return this.$toastr.e("delete failed") }

        this.$emit('refresh'), this.$toastr.s('Removed'), this.list();
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText) , this.list() }
    },
    list() { this.$router.push({ name: 'wmds_policy'}); },
    async save() {
      let config = this.model;
      try {
        let rs = await Api.Manager_Call('wmds.policy', this.model.id ? 'update' : 'insert', config);
        if(rs.error) { this.cancel(); return this.$toastr.e("load failed") }

        let id = rs.body.id
        this.$router.push({ name: 'wmds_policy', params : { id : id } })

        this.$toastr.s('Saved');
        this.refresh()
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText); this.list();  }
      this.lock = true;
    },
    async get({ id, tag } = this.$route.params) {
      try{
        this.add = false;
        console.log('policy.detail.vue', 'load item', id);

        if(id === 'add') { this.check_max_page(); this.add = true; this.lock = false; return; }

        this.lock = (tag !== 'edit');

        let rs = await Api.Manager_Call('wmds.policy', 'detail', { id : id })
        if(rs.error) { return this.$toastr.e("load failed", this.$route.name) }
        this.model = Object.assign({ group: {}}, this.model, rs.body)
      }catch(e){ this.$toastr.e(e.data ? e.data.message : e.statusText) , this.list() }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params); } },
  created() { console.log('policy.detail.vue', 'created'); },
  destroyed() { console.log('policy.detail.vue', 'destroyed'); },
  mounted() {
    console.log('policy.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
</script>
